import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { mdmLevels } from '../data/emCalculator';

const { FiCheckCircle, FiInfo } = FiIcons;

function EmCalculatorOutput({
  mode,
  patientType,
  selectedLevels,
  calculatedLevel,
  timeResult
}) {
  const level = mdmLevels.find((item) => item.key === calculatedLevel);
  const achievedCount = Object.values(selectedLevels).filter(
    (item) => item >= mdmLevels.findIndex((levelItem) => levelItem.key === calculatedLevel)
  ).length;

  if (mode === 'time' && !timeResult) {
    return (
      <aside className="em-output-card is-empty">
        <SafeIcon icon={FiInfo} />
        <h2>Enter total physician time</h2>
        <p>Use the time documented on the date of encounter to calculate the time-based code.</p>
      </aside>
    );
  }

  const title = mode === 'time' ? 'Time-based result' : `${level.title} MDM`;
  const code = mode === 'time' ? timeResult.code : level && (
    patientType === 'new'
      ? { straightforward: '99202', low: '99203', moderate: '99204', high: '99205' }[level.title.toLowerCase()]
      : { straightforward: '99211', low: '99212', moderate: '99214', high: '99215' }[level.title.toLowerCase()]
  );

  return (
    <aside className="em-output-card">
      <span className="content-label">Calculated result</span>
      <div className="em-result-code">{code}</div>
      <h2>{title}</h2>

      {mode === 'time' ? (
        <p className="em-result-reason">
          {timeResult.range} on the date of encounter maps to {timeResult.code}.
        </p>
      ) : (
        <p className="em-result-reason">
          {level.label} level met because {achievedCount} of 3 elements achieved
          {level.label} or higher.
        </p>
      )}

      <div className="em-tip-box">
        <SafeIcon icon={FiCheckCircle} />
        <div>
          <strong>Documentation tip</strong>
          <p>{mode === 'time' ? 'Document total physician time on the date of encounter.' : level.tip}</p>
        </div>
      </div>

      <p className="em-disclaimer">
        Educational calculator only. Verify current AMA, CMS, payer, and organizational
        guidance before assigning a final code.
      </p>
    </aside>
  );
}

export default EmCalculatorOutput;